export type CashMovementType = "PARTNER_WITHDRAWAL" | "EXPENSE";

export type PaymentSource = "CASH" | "UPI";

export type ExpenseCategory =
	| "Stock Purchase"
	| "Rent"
	| "Electricity"
	| "Salary"
	| "Repair/Maintenance"
	| "Transport"
	| "Packaging"
	| "Miscellaneous";

export const expenseCategories: ExpenseCategory[] = [
	"Stock Purchase",
	"Rent",
	"Electricity",
	"Salary",
	"Repair/Maintenance",
	"Transport",
	"Packaging",
	"Miscellaneous"
];

export interface CashMovementData {
	type: CashMovementType;
	amount: number;
	movementDate: string;
	description: string;
	paymentSource: PaymentSource;
	personName?: string;
	expenseCategory?: ExpenseCategory;
	vendorName?: string;
	createdAt: string;
	userId: string;
	username: string;
	isVoided?: boolean;
}

export interface CashMovementRecord extends CashMovementData {
	id: string;
}
